var o,n;!function(o){o.MODAL="modal",o.POPOVER="popover"}(o||(o={})),function(o){o.NONE="none",o.SMALL="small",o.MEDIUM="medium",o.LARGE="large"}(n||(n={}));export{n as DialogSize,o as DialogType};
//# sourceMappingURL=DialogContentContainerConstants.js.map
